export enum ILocales {
    default = 'default',
    en_NZ = 'nz',
    en_AU = 'au',
}

export enum I18nLocales {
    nz = 'en-NZ',
    au = 'en-AU',
}

export enum ICountries {
    NewZealand = 'New Zealand',
    Australia = 'Australia',
}
